import React, { lazy, Suspense } from 'react';
import { useStoreInfo } from 'commons/hooks';
import { GetRefundReceiptDetailsResponse } from 'commons/services/refundReceiptService';

const LazyPDFRefundReceiptDownloadLink = lazy(
  () => import('./PDFRefundReceiptDownloadLink'),
);

interface PDFDownloadLinkProps {
  storeDocument: string;
  refundDetails: GetRefundReceiptDetailsResponse;
  as?: 'a' | 'button';
}

function PDFDownloadLink({
  storeDocument,
  refundDetails,
  as,
}: Readonly<PDFDownloadLinkProps>) {
  const { storeInfo } = useStoreInfo();

  return (
    <Suspense fallback={null}>
      <LazyPDFRefundReceiptDownloadLink
        as={as}
        refundDetails={refundDetails}
        storeDocument={storeDocument}
        storeInfo={storeInfo}
      />
    </Suspense>
  );
}

export default PDFDownloadLink;
